<template>
  <div class="menu">
    <MenuSection
      section-header="common.masterData"
      :menu-items="masterDataItems"
    />
    <MenuSection
      section-header="common.integrations"
      :menu-items="casinoItems"
    />
    <MenuSection
      section-header="common.games"
      :menu-items="gameItems"
    />
    <MenuSection
      section-header="common.bridges"
      :menu-items="bridgeItems"
    />
    <MenuSection
      section-header="common.support"
      :menu-items="supportItems"
    />
    <MenuSection
      section-header="common.reporting"
      :menu-items="reportingItems"
    />
    <MenuSection
      section-header="common.cpv"
      :menu-items="cpvItems"
    />
    <MenuSection
      section-header="common.user"
      :menu-items="userItems"
    />
  </div>
</template>

<script>
  import MenuSection from './MenuSection'

  export default {
    name: 'SideBar',
    components: { MenuSection },
    computed: {
      masterDataItems(){
        return [
          {
            name: 'masterData.jurisdictions',
            icon: 'fas fa-book',
            path: { name: 'casino-jurisdiction-list' }
          }
        ]
      },
      casinoItems (){
        return [
          {
            name: 'common.manage',
            icon: 'fas fa-tasks',
            path: {name: 'manage-integrations'}
          },
          {
            name: 'common.casinos',
            icon: 'fas fa-dice-six',
            path: {name: 'manage-casinos'}
          },
          {
            name: 'common.games',
            icon: 'fas fa-gamepad',
            path: {name: 'integration-games'}
          },
          {
            name: 'casinos.integrationOptions',
            icon: 'fas fa-filter',
            path: { name: 'casino-integration-option-list' }
          }
        ]
      },
      gameItems (){
        return [
          {
            name: 'common.manage',
            icon: 'fas fa-tasks',
            path: {name: 'manage-games'}
          },
          {
            name: 'common.versions',
            icon: 'fas fa-code-branch',
            path: {name: 'game-versions'}
          },
          {
            name: 'common.integrations',
            icon: 'fas fa-dice',
            path: {name: 'game-integrations'}
          }
        ]
      },
      bridgeItems (){
        return [
          {
            name: 'common.manage',
            icon: 'fas fa-tasks',
            path: {name: 'manage-bridges'}
          }
        ]
      },
      reportingItems (){
        return [
          {
            name: 'reporting.reports',
            icon: 'fas fa-file-download',
            path: {name: 'report-list'}
          },
          {
            name: 'reporting.gamePerformanceReports',
            icon: 'fas fa-chart-area',
            path: {name: 'game-performance-report-list'}
          },
          {
            name: 'reporting.casinoPerformanceReport',
            icon: 'fas fa-chart-pie',
            path: {name: 'casino-performance-report-list'}
          },
          {
            name: 'reporting.significantEvents',
            icon: 'fas fa-exclamation-circle',
            path: {name: 'significant-event-list'}
          },
        ]
      },
      cpvItems () {
        return [
          {
            name: 'reporting.cpvChecks',
            icon: 'fas fa-clipboard-list',
            path: {name: 'cpv-check-list'}
          },
          {
            name: 'cpv.allowedHashes',
            icon: 'fas fa-hashtag',
            path: {name: 'allowed-hash-list'}
          }
        ]
      },
      supportItems () {
        return [
          {
            name: 'support.openGameRounds',
            icon: 'fas fa-circle-notch',
            path: { name: 'open-game-round-list' }
          }
        ]
      },
      userItems (){
        return [
          {
            name: 'common.logout',
            icon: 'fas fa-sign-out-alt',
            path: {name: 'logout'}
          }
        ]
      },
    }
  }
</script>

<style lang='scss'  scoped>
</style>
